module.exports = __webpack_public_path__ + "img/cv-motiongraphics.e72e5bf.jpg";